// Block 9 — signed-in shell, demo bar, learning page
const en = {
  b9: {
    account: "Account menu",
    mine: "My account",
    admin: "Admin",
    demo_info: "About this demo",
    more: "More demo actions",
    start_short: "Start",
    continue_title: "Continue learning",
    continue_btn: "Continue",
    start_btn: "Start",
    preview_btn: "Preview",
    open_btn: "Open course",
    progress: "{{done}} of {{total}} steps done",
    lessons_one: "{{count}} lesson",
    lessons_other: "{{count}} lessons",
    last_opened: "Last opened: {{unit}}",
    dir: { A: "A — Preventive Skin and Coat Care", B: "B — Supportive Care for a Compromised Coat", C: "C — Puppy Preparation for Grooming", D: "D — Return to Grooming After Adverse Experience" },
    first_steps: "First steps",
    step_n: "Step {{n}} of {{total}}",
    dismiss: "Hide first steps",
    show_steps: "Show first steps",
    choose_dir: "Choose the direction you want to start with",
    why_dir: "Each direction has its own course — tap one to open it.",
    why_ex: "An example shows how lessons connect to a real programme.",
    why_case: "A training dog lets you practise without touching real client records.",
    open_intro: "Open the introduction",
    illustration: "Illustration",
    example_photo: "Example photo",
  },
};
const ru = {
  b9: {
    account: "Меню аккаунта",
    mine: "Мой аккаунт",
    admin: "Администрирование",
    demo_info: "Об этом демо",
    more: "Другие действия демо",
    start_short: "Начать",
    continue_title: "Продолжить обучение",
    continue_btn: "Продолжить",
    start_btn: "Начать",
    preview_btn: "Ознакомиться",
    open_btn: "Открыть курс",
    progress: "Выполнено {{done}} из {{total}}",
    lessons_one: "{{count}} урок",
    lessons_few: "{{count}} урока",
    lessons_many: "{{count}} уроков",
    lessons_other: "{{count}} урока",
    last_opened: "Последний раз: {{unit}}",
    dir: { A: "A — Профилактический уход за кожей и шерстью", B: "B — Поддерживающий уход при проблемной шерсти", C: "C — Подготовка щенка к грумингу", D: "D — Возвращение к грумингу после неприятного опыта" },
    first_steps: "Первые шаги",
    step_n: "Шаг {{n}} из {{total}}",
    dismiss: "Скрыть первые шаги",
    show_steps: "Показать первые шаги",
    choose_dir: "Выберите направление, с которого хотите начать",
    why_dir: "У каждого направления свой курс — нажмите, чтобы открыть его.",
    why_ex: "Пример показывает, как уроки связаны с реальной программой.",
    why_case: "Учебная собака позволяет практиковаться, не затрагивая реальные записи клиентов.",
    open_intro: "Открыть введение",
    illustration: "Иллюстрация",
    example_photo: "Пример фото",
  },
};
export default { en, ru };
